window.addEventListener('DOMContentLoaded', ()=>{
    const container = document.querySelector('.wp-block-lazyblock-featured-products')
    if(!container) {
        return
    }
    const buttonContainer = container.querySelector('.category-buttons')
    const buttons = buttonContainer.querySelectorAll('button');
        
    buttons.forEach((button)=>{
        button.addEventListener("click", (e)=>{
            const selectedButton = (e).target;        
            // Dim all buttons
            buttons.forEach((buttonIter)=>{
                buttonIter.classList.remove('btn-primary');
                buttonIter.classList.add('btn-light');
            })

            //Light Selected Button
            selectedButton.classList.remove('btn-light');
            selectedButton.classList.add('btn-primary');
    
        })
    })
})